/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CardContent } from '../../models/card-content';
import { CardContentApiRespModel } from '../../models/card-content-api-resp-model';

export interface ApiMasterCardContentEditPost$Params {
      body?: CardContent
}

export function apiMasterCardContentEditPost(http: HttpClient, rootUrl: string, params?: ApiMasterCardContentEditPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CardContentApiRespModel>> {
  const rb = new RequestBuilder(rootUrl, apiMasterCardContentEditPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CardContentApiRespModel>;
    })
  );
}

apiMasterCardContentEditPost.PATH = '/api/Master/CardContent/Edit';
